
import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/common";
const commonState = namespace("Common");

import "@/store/modules/forms/form1";
const form1State = namespace("Form1");

import styleOfProceedingActions from './StyleOfProceedingComponents/styleOfProceedingsActions.vue'
import { form1DataInfoType, form1StatesInfoType, lookupsInfoType, form1PartiesStatesInfoType, form1PartiesInfoType } from '@/types/Information/Form1';
import { partiesContact } from '@/types/Information';
import {getPartyTitles, getFullName} from "./PartyTitles"

@Component({
    components:{ 
        styleOfProceedingActions        
    }
})
export default class FillForm1StyleOfProceedingsInfo extends Vue {    

    @form1State.State
    public form1Info: form1DataInfoType;

    @form1State.State
    public form1InfoStates: form1StatesInfoType;

    @commonState.State
    public userName!: string;

    @commonState.State
    public lookups!: lookupsInfoType;    

    @form1State.Action
    public UpdateForm1Info!: (newForm1Info: form1DataInfoType) => void

    partiesFields = [
        {
            key:'app',          
            label:'Appellant(s)',                  
            thClass: 'text-white bg-primary text-center',            
            sortable:false            
        }, 
        {
            key:'appAction',          
            label:'',   
            thClass: 'text-white bg-primary text-center',           
            sortable:false            
        }, 
        {
            key:'title',          
            label:'Party (Not affected by the Appeal)',                  
            thClass: 'text-white bg-primary text-center',            
            sortable:false            
        }, 
        {
            key:'resAction',          
            label:'',   
            thClass: 'text-white bg-primary text-center',           
            sortable:false            
        },        
        {
            key: "res",
            label: "Respondent(s)",            
            thClass: 'text-white bg-primary text-center',
            sortable: false
        }
    ]      
    
   
    dataReady = false;  
    respondentNames = '';
    respondents: string[] = [];   
    respondentSolicitors: string[] = []; 
    
    applicantNameList: string[] = [];
    respondentNameList: string[] = [];
   
    updated = 0;
    showConfirmEditParties = false;
    rowInfo;
    moveLeft = false;
    moveApp = false;
    
    styleOfProceedingsInfo = {} as form1DataInfoType;
    form1PartiesStates = {} as form1PartiesStatesInfoType; 

    @Watch('respondents')
    setRespondentNames(newRespondents: string[]) 
    {
        //console.log("RESP WATCH")
        this.respondentNames = newRespondents.join('; ');
        this.styleOfProceedingsInfo = this.form1Info;
        this.styleOfProceedingsInfo.respondentSolicitor = this.respondentSolicitors.join('; ');
        this.UpdateForm1Info(this.styleOfProceedingsInfo);
    }

    mounted() { 
        this.dataReady = false;
        this.styleOfProceedingsInfo = this.form1Info;   
        this.respondents = [];
        this.respondentSolicitors = [];     
        this.extractInfo();
        this.form1PartiesStates = {} as form1PartiesStatesInfoType;
        this.dataReady = true;                   
    }

    public extractInfo(){

        const styleOfProceedings = this.form1Info;       
        
        styleOfProceedings.appellants = [];
        styleOfProceedings.respondents = [];
        this.applicantNameList = [];
        this.respondentNameList = [];              

        for (const partyInfo of styleOfProceedings.parties){
                           
            partyInfo.fullName = getFullName(partyInfo);
            
            partyInfo.title = getPartyTitles(partyInfo, '</br>', false);

            if (partyInfo.appealRole == "Respondent"){
                styleOfProceedings.respondents.push(partyInfo);
                this.respondentNameList.push(partyInfo.fullName);

            } else if (partyInfo.appealRole == "Appellant"){
                styleOfProceedings.appellants.push(partyInfo);
                this.applicantNameList.push(partyInfo.fullName);
            }                                 
        }
        
        // for (const respondent of styleOfProceedings.respondents){
        //     this.respondents.push(respondent.fullName);
        //     if (respondent.counselName) {
        //         this.respondentSolicitors.push(respondent.counselName);
        //     }
        // }
        // styleOfProceedings.respondentSolicitor = this.respondentSolicitors.join(', ');     

        this.UpdateForm1Info(styleOfProceedings)
        this.updateAddressFields();
    }  
   

    public updateTableResults(){
        //console.log('updating')
        this.styleOfProceedingsInfo = this.form1Info;
        this.extractInfo();
        // this.updateAddressFields(); 
        this.recheckStates()  
    }

    public updateAddressFields(){

        const formData = this.form1Info;
        const addressData = formData.addresses;
        const addresses: partiesContact[] = []; 
        const emailData = formData.emailAdresses;
        const emails: partiesContact[] = []; 
        const phoneData = formData.phoneNumbers;
        const phoneNumbers: partiesContact[] = []; 

        for (const partyName of this.applicantNameList){
           
            const matchingAddressRecords = addressData.filter(address => address.name == partyName);

            if (matchingAddressRecords.length == 0){
                addresses.push({name: partyName, contactInfo: ''});
            } else {                
                const index = addressData.findIndex(address => address.name == matchingAddressRecords[0].name);               
                addresses.push(addressData[index]);
            }

            const matchingPhoneRecords = phoneData.filter(phone => phone.name == partyName); 
            
            if (matchingPhoneRecords.length == 0){
                phoneNumbers.push({name: partyName, contactInfo: ''});
            } else {                
                const index = phoneData.findIndex(phone => phone.name == matchingPhoneRecords[0].name);               
                phoneNumbers.push(phoneData[index]);
            }

            const matchingEmailRecords = emailData.filter(email => email.name == partyName); 
            
            if (matchingEmailRecords.length == 0){
                emails.push({name: partyName, contactInfo: ''});
            } else {                
                const index = emailData.findIndex(email => email.name == matchingEmailRecords[0].name);               
                emails.push(emailData[index]);
            }
        }

        formData.addresses = addresses;
        formData.emailAdresses = emails;
        formData.phoneNumbers = phoneNumbers;
        this.UpdateForm1Info(formData)

        this.updated ++;               
    } 

    public showConfirmEditParty(row, app, left){

        this.rowInfo = row;
        this.moveApp = app;
        this.moveLeft = left;
        if (this.form1Info.manualSop?.length > 0){
            this.showConfirmEditParties = true;
        } else {
            this.confirmEditPartyAppealRoles();
        }
        this.recheckStates()    
    }

    public cancelShowConfirmEditParties(){
        this.showConfirmEditParties = false;
    }

    public confirmEditPartyAppealRoles(){
        
        this.showConfirmEditParties = false;
        if (this.moveLeft){

            if (this.moveApp){
                this.appLeft(this.rowInfo);
            } else {
                this.resLeft(this.rowInfo)
            }

        } else {

            if (this.moveApp){
                this.appRight(this.rowInfo);
            } else {
                this.resRight(this.rowInfo)
            }

        }
        const styleOfProceedings = this.form1Info;
        styleOfProceedings.manualSop = [];
        this.UpdateForm1Info(styleOfProceedings);
    }    

    public appLeft(row){ 
        const styleOfProceedings = this.form1Info;
        styleOfProceedings.parties[row.index].appealRole = 'Appellant';        
        styleOfProceedings.appellants.push(styleOfProceedings.parties[row.index]);
        this.applicantNameList.push(styleOfProceedings.parties[row.index].fullName);
        this.UpdateForm1Info(styleOfProceedings);
        this.updateAddressFields();
    }

    public appRight(row){          
        const styleOfProceedings = this.form1Info; 
        styleOfProceedings.parties[row.index].appealRole = '';
        const index = styleOfProceedings.appellants.findIndex(app => app.fullName == styleOfProceedings.parties[row.index].fullName)
        styleOfProceedings.appellants.splice(index, 1);
        this.applicantNameList.splice(index, 1);        
        this.UpdateForm1Info(styleOfProceedings);
        this.updateAddressFields();
    }

    public resLeft(row){
        const styleOfProceedings = this.form1Info;
        styleOfProceedings.parties[row.index].appealRole = '';        
        const resNameIndex =  this.respondents.indexOf(styleOfProceedings.parties[row.index].fullName);
        this.respondents.splice(resNameIndex, 1);
        if (styleOfProceedings.parties[row.index].counselName) {            
            const solicitorNameIndex =  this.respondentSolicitors.indexOf(styleOfProceedings.parties[row.index].counselName);
            this.respondentSolicitors.splice(solicitorNameIndex, 1);
        }
         
        const index = styleOfProceedings.respondents.findIndex(res => res.fullName == styleOfProceedings.parties[row.index].fullName)
        styleOfProceedings.respondents.splice(index, 1);
        styleOfProceedings.respondentSolicitor = this.respondentSolicitors.join(', ');
        this.UpdateForm1Info(styleOfProceedings);
        this.updated ++;
    }

    public resRight(row){
        const styleOfProceedings = this.form1Info;
        styleOfProceedings.parties[row.index].appealRole = 'Respondent';
        
        this.respondents.push(styleOfProceedings.parties[row.index].fullName);
        if (styleOfProceedings.parties[row.index].counselName) {
            this.respondentSolicitors.push(styleOfProceedings.parties[row.index].counselName);
        }        
        styleOfProceedings.respondents.push(styleOfProceedings.parties[row.index]);
        styleOfProceedings.respondentSolicitor = this.respondentSolicitors.join(', ');
        this.UpdateForm1Info(styleOfProceedings);
        this.updated ++;
    }

    public helpText(content: string){
        return {title: "<div style='margin: 0;'>" +content+ "</div>"};
    }

    public update(){ 
        this.UpdateForm1Info(this.styleOfProceedingsInfo);
        this.recheckStates()
    } 

    public recheckStates(){
        this.$emit('recheckStates')
    }   

}
